<div class="donut-chart" [id]="id"></div>
